import LESSON_FRAGMENT from 'graph/fragments/lesson';
import LESSON_COMPLETION_STATS_FRAGMENT from 'graph/fragments/lesson-completion-stats';
import gql from 'graphql-tag';

// District skills progress panel
const GET_CURRICULUM_LESSON_REPORT = gql`
  query getCurriculumLessonReport($where: PrmCurriculumLessonReportWhereInput!) {
    prmCurriculumLessonReport(where: $where) {
      productCurriculum {
        id
        code
        name
      }
      averageLessonAssignedCount
      averageLessonCompletedCount
      totalLessonCount
      overallCompletionStats {
        ...BaseLessonCompletionStatsFragment
      }
      lessons {
        ...BaseLessonFragment
      }
    }
  }
  ${LESSON_FRAGMENT}
  ${LESSON_COMPLETION_STATS_FRAGMENT}
`;

export default GET_CURRICULUM_LESSON_REPORT;
